// @flow

import React, { Component, createRef } from "react"
import get from "lodash/get"
import posed from "react-pose"
import { autobind } from "core-decorators"
import IntlStore from "../stores/IntlStore"
import styles from "./ErrorDetails.scss"

type Props = {
  error: Error
}

type State = {
  showMore: boolean,
  initialHeight: number
}

const MoreDetails = posed.div({
  show: {
    opacity: 1,
    height: props => props.initialHeight
  },
  hide: {
    opacity: 0,
    height: 0
  }
})

@autobind
class ErrorDetails extends Component<Props, State> {
  moreDetailsRef: any = createRef()

  state: State = {
    showMore: false,
    initialHeight: 0
  }

  onShowMore(e: Event) {
    e.preventDefault()

    this.setState({ showMore: !this.state.showMore })
  }

  componentDidMount() {
    this.setState({ initialHeight: this.moreDetailsRef.current.scrollHeight })
  }

  render(): null | React$Element<"div"> {
    const requestUrl = get(this.props.error, "request.responseURL")
    const errors = get(this.props.error, "response.data.errors")

    if (!requestUrl) return null

    return (
      <div className={styles.container}>
        <a className={styles.showMore} onClick={this.onShowMore}>
          <span>{IntlStore.formatMessage("common.showDetails")}...</span>
        </a>

        <MoreDetails
          className={styles.moreDetails}
          initialHeight={this.state.initialHeight}
          pose={this.state.showMore ? "show" : "hide"}
          ref={this.moreDetailsRef}
        >
          <span>Request URL:</span>
          <pre className={styles.detailedInfo}>{requestUrl}</pre>
          <span>Message:</span>
          <pre className={styles.detailedInfo}>
            {errors.map(error => error.message)}
          </pre>
        </MoreDetails>
      </div>
    )
  }
}

export default ErrorDetails
